import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { useFileDownload } from '../../../../components/file-download';
import { GuardedComponent } from '../../../../components/guarded-component';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { fileUploadApiKeyStore } from '../../../../api/file-upload-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { useEffect, useState } from 'react';
import { FileUploadComponent } from './file-upload.component';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useSaveData } from '../../../../hooks/useSaveData';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../../../hooks/use-debounce';

interface FilesTab {
  unitID: number;
}
export const FilesTab = ({ unitID }: FilesTab) => {

  const [editItem, setEditItem] = useState<any>();
  const { downloadFile, isLoading } = useFileDownload();


  const handleDialogClosed = () => { setEditItem(undefined); }

  const handleUploadFile = () => { setEditItem({}); }

  const handleEditFile = (value: any) => {
    setEditItem(value);
  };

  const handleDownloadFile = async (data: any) => {
    downloadFile({ additionalData: data });
  };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('UnitDetailFile', 'UnitDetailFile')
  );

  const { isLoading: isFileUploadLoading, data: UnitDetailFiles, refetch } = useLoadData<ApiResponse<any[]>>(fileUploadApiKeyStore.getFiles({ unitID: unitID }));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnitDetailFiles, setFilteredUnitDetailFiles] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitDetailFileList = UnitDetailFiles?.data?.filter((UnitDetailFile) =>
      Object.values(UnitDetailFile).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnitDetailFiles(filteredUnitDetailFileList || []);
  }, [debouncedSearchTerm, UnitDetailFiles?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'UnitDetailFile',
      pageName: 'UnitDetailFile',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'UnitDetailFile',
      pageName: 'UnitDetailFile',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  return (
    <div className="borderTop">
      <GuardedComponent requiredPermissions={[UserPermissionName.UPLOAD_FILE]}>
        <Button
          className="innerTab-button"
          size="small"
          variant="contained"
          disableElevation={true}
          startIcon={<AddIcon />}
          onClick={handleUploadFile}
        >
          Upload File
        </Button>
      </GuardedComponent>
      <SiTrackGrid
        fileTitle='unit_file'
        dataItemKey="fileID"
        columns={columns}
        // queryConfig={fileUploadApiKeyStore.getFiles({ unitID: unitID })}
        onDownload={(data: any) => {
          handleDownloadFile(data);
        }}
        onEdit={handleEditFile}
        deleteMutationConfig={(item) => fileUploadApiKeyStore.deleteFile(item.fileID)}
        actionPermissions={{
          edit: UserPermissionName.EDIT_FILE,
          download: UserPermissionName.DOWNLOAD_FILE,
          export: UserPermissionName.DOWNLOAD_GRID
        }}
        isBusy={isLoading || isFileUploadLoading || isLoadingGridLayout}

        // -----------------Grid Layout-------
        dataItems={filteredUnitDetailFiles || []}
        reorderable
        handleSearch={handleInputChange}
        handleSaveLayout={handleSaveLayout}
        isSaveLayout={true}
        gridConfigFromApi={gridConfig}
        handleResetLayout={handleResetLayout}
      // -----------------Grid Layout-------
      />
      {
        editItem && (
          <FileUploadComponent
            unitID={unitID}
            fileData={editItem}
            onClosed={handleDialogClosed} />
        )
      }
    </div>
  );
};
